import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {AthletesResponseApiModel} from "../models/athletes.response-api-model";
import {AthletesDataSource} from "../models/athletes-data.source";
import {CountryDomainModel} from "../../common/country/models/country-domain-model";
import {CountryApiModel} from "../../common/country/models/country-api-model";
import {CompetitorDomainModel} from "../../common/competitor/models/competitor-domain-model";
import {SportDomainModel} from "../../sports/models/sport-domain-model";
import {AthleteApiModel} from "../../common/athlete/athlete-api-model";
import {AthleteDomainModel} from "../../common/athlete/athlete-domain-model";
import {CompetitorFactory} from "../../common/competitor/domain-services/competitor-factory";
import {CompetitionFactory} from "../../common/competition/domain-services/competition-factory";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {SportApiModel} from "../../sports/models/sport-api-model";
import {Type} from "../../../infrastructure/type";
import {CountryFactory} from "../../common/country/domain-services/country-factory";
import {SportsFactory} from "../../sports/domain-services/sports.factory";

export class AthletesFactory extends BaseFactory {
  competitorFactory: CompetitorFactory;
  competitionFactory: CompetitionFactory;
  countryFactory: CountryFactory;
  sportFactory: SportsFactory;

  static injectables = [...BaseFactory.injectables, CompetitionFactory, CompetitorFactory, CountryFactory, SportsFactory];

  constructor(loggerUtils: LoggerUtils, termsUtils: TermsUtils, competitionFactory: CompetitionFactory, competitorFactory: CompetitorFactory, countryFactory: CountryFactory, sportFactory: SportsFactory) {
    super(loggerUtils, termsUtils);

    this.competitorFactory = competitorFactory;
    this.competitionFactory = competitionFactory;
    this.countryFactory = countryFactory;
    this.sportFactory = sportFactory;
  }
  createResponse(apiModel: AthletesResponseApiModel) {
    const responseApiModel: AthletesResponseApiModel = new AthletesResponseApiModel(apiModel);

    return responseApiModel;
  }

  createDomainModel(model): AthletesDataSource {
    const countries: Map<Number, CountryDomainModel> = new Map();

    model.countries?.forEach((country: CountryApiModel) => {
      countries.set(country.id, new CountryDomainModel(country));
    });

    const competitors: Map<Number, CompetitorDomainModel> = this.competitorFactory.createDomainMap(model.competitors, CompetitorDomainModel, 'id', model.sports, model.countries);
    const sports: Map<Number, SportDomainModel> = this.createDomainMap(model.sports, SportDomainModel, 'id');

    let athletes: AthleteDomainModel = model.athletes?.map((athlete: AthleteApiModel) => {
      const isNational: Boolean = this.competitorId === athlete.nationalTeamId;
      const club: CompetitorDomainModel = competitors.get(athlete.clubId);
      const sport: SportDomainModel = sports.get(athlete.sportId);
      const nationalTeam: CompetitorDomainModel = competitors.get(athlete.nationalTeamId);

      return new AthleteDomainModel(athlete, countries.get(athlete.nationalityId), club, sport, isNational, false, null, nationalTeam);
    });

    const domain: AthletesDataSource = new AthletesDataSource(athletes);

    return domain;
  }

  createDomainMap(athletes: Array<AthleteApiModel>, type: Type, key: String,sports: Array<SportApiModel>, countries: Array<CountryApiModel>, competitors: Array<CompetitorDomainModel>, isNational: Boolean) {
    const countriesMap: Map<Number, CountryDomainModel> = this.countryFactory.createDomainMap(countries, CountryDomainModel);
    const sportsMap: Map<Number, SportDomainModel> = this.sportFactory.createDomainMap(sports, SportDomainModel);
    const map: Map<Number, CompetitorDomainModel> = new Map();

    athletes?.forEach((athleteApiModel: AthleteApiModel, index: Number) => {
      const country: CountryDomainModel = countriesMap.get(athleteApiModel.nationalityId);
      const sport: SportDomainModel = sportsMap.get(athleteApiModel.sportId);

      const athleteDomainModel: AthleteDomainModel = new AthleteDomainModel(athleteApiModel, country, null, sport, isNational);
      athleteDomainModel.sortIndex = index;

      map.set(athleteDomainModel.id, athleteDomainModel);
    });

    return map;
  }
}

